var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourceAllocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524.48 416C736 416 896 333.44 896 224s-160-192-371.52-192C333.76 32 128 105.28 128 224s205.76 192 396.48 192z m0-320C705.6 96 832 163.52 832 224s-126.4 128-307.52 128S192 281.92 192 224s148.48-128 332.48-128zM182.72 777.28a32 32 0 0 0-5.12-3.84 17.6 17.6 0 0 0-5.44-2.88 19.84 19.84 0 0 0-6.08-2.56 32 32 0 0 0-28.8 8.64 36.8 36.8 0 0 0-6.72 10.56A32 32 0 0 0 128 800a26.56 26.56 0 0 0 2.56 12.16 37.12 37.12 0 0 0 6.72 10.56 36.8 36.8 0 0 0 10.56 6.72 30.08 30.08 0 0 0 24.32 0 37.12 37.12 0 0 0 10.56-6.72 37.12 37.12 0 0 0 6.72-10.56 30.08 30.08 0 0 0 0-24.32 36.8 36.8 0 0 0-6.72-10.56zM390.08 915.2a469.44 469.44 0 0 1-137.28-47.04 32 32 0 0 0-32 55.68 535.36 535.36 0 0 0 156.48 54.08h6.08a32 32 0 0 0 6.08-64zM844.48 738.56a32 32 0 0 0-16.64 41.92A48.32 48.32 0 0 1 832 800c0 60.48-126.4 128-307.52 128H512a32 32 0 0 0 0 64h13.12C736 992 896 909.44 896 800a112.64 112.64 0 0 0-9.28-44.48 32 32 0 0 0-42.24-16.96z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.48 354.56a32 32 0 0 0-16.64 41.92A48.32 48.32 0 0 1 832 416c0 60.48-126.4 128-307.52 128S192 473.92 192 416a39.36 39.36 0 0 1 4.48-17.92 32 32 0 1 0-57.28-28.48A103.68 103.68 0 0 0 128 416c0 118.72 205.76 192 396.48 192C736 608 896 525.44 896 416a112.64 112.64 0 0 0-9.28-44.48 32 32 0 0 0-42.24-16.96z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.48 546.56a32 32 0 0 0-16.64 41.92A48.32 48.32 0 0 1 832 608c0 60.48-126.4 128-307.52 128S192 665.92 192 608a39.36 39.36 0 0 1 4.48-17.92 32 32 0 1 0-57.28-28.48A103.68 103.68 0 0 0 128 608c0 118.72 205.76 192 396.48 192C736 800 896 717.44 896 608a112.64 112.64 0 0 0-9.28-44.48 32 32 0 0 0-42.24-16.96z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceAllocation);
export default __webpack_public_path__ + "static/media/resource-allocation.d24f011f801560dc029f3cae0076a795.svg";
export { ForwardRef as ReactComponent };